import { pdfjs } from 'react-pdf';

/**
 * Единственный источник правды по конфигу pdf.js в проекте.
 *
 * Импорт этого модуля настраивает worker (side effect), поэтому его нельзя
 * тянуть в App.tsx / корневой bootstrap — только в точках, где реально
 * открывается PDF.
 */
pdfjs.GlobalWorkerOptions.workerSrc = '/pdfjs.2.12.313.worker.js';

/**
 * Митигация CVE-2024-4367 / GHSA-wgrm-67xf-hhpq (pdfjs-dist < 4.2.67).
 *
 * При `isEvalSupported: true` (дефолт pdf.js) вредоносный PDF может выполнить
 * произвольный JS в origin приложения через путь компиляции глифов шрифтов
 * (`/FontMatrix` → `new Function` в `FontFaceObject.getPathGenerator`).
 * Флаг `false` закрывает этот eval-путь.
 *
 * Константу обязательно подключать в КАЖДОЙ точке загрузки PDF
 * (`<Document options={...} />`, `pdfjs.getDocument({ ...PDFJS_SECURITY_OPTIONS })`).
 * Локальные копии флага заводить нельзя — они расходятся между файлами
 * и теряются при добавлении нового вьювера.
 */
export const PDFJS_SECURITY_OPTIONS = {
    isEvalSupported: false,
};
